<script>
	import { page } from '$app/stores';

	const langs = [
	{ code: 'en', path: 'en' },
	{ code: 'id', path: 'id' },
	{ code: 'ru', path: 'ru' },
	{ code: 'zh', path: 'cn' },
	{ code: 'ko', path: 'kr' }
];
	const defaultLang = 'en';

	$: path = $page.url.pathname;
	$: currentLang = path.match(/^\/(en|id|ru|cn|kr)(\/|$)/)?.[1] ?? defaultLang;
	$: purePath = path
		.replace(/^\/(en|id|ru|cn|kr)(\/|$)/, '/')
		.replace(/\/$/, '') || '/';

	// Jika di homepage → jangan tambahkan slash
	$: canonicalUrl = purePath === '/'
		? `https://balinusadua.holidayinnresorts.com/${currentLang}`
		: `https://balinusadua.holidayinnresorts.com/${currentLang}${purePath}`;
</script>

<svelte:head>
	<!-- Canonical -->
	<link rel="canonical" href={canonicalUrl} />

	<!-- Hreflang alternate -->
	{#each langs as lang}
		<link
		rel="alternate"
		hreflang={lang.code}
		href={`https://balinusadua.holidayinnresorts.com/${lang.path}${purePath === '/' ? '' : purePath}`} />
	{/each}
	<!-- Hreflang default -->
	<link
		rel="alternate"
		hreflang="x-default"
		href={`https://balinusadua.holidayinnresorts.com/${defaultLang}${purePath === '/' ? '' : purePath}`} />
</svelte:head>

<main>
	<slot />
</main>